import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from 'src/app/common/base/base.component';
import { Form } from 'src/app/services/forms/form';
import { PpstbService } from '../../ppstb.service';

@Component({
  selector: 'ppstb-main-s4',
  templateUrl: './ppstb-main-s4.component.html',
  styleUrls: ['./ppstb-main-s4.component.scss']
})
export class PpstbMainS4Component extends BaseComponent {

  @Input() form?: Form | null;
  @Input() disabled!: boolean;
  @Input() service?: PpstbService;

}
